import { MutationTree } from 'vuex';
import { IProfileNotificationState } from './profile-notification-state.store';
import { PROFILE_NOTIFICATION_LOADING, PROFILE_SET_NOTIFICATION, PROFILE_SET_NOTIFICATION_ROWS, REVERT_PROFILE_NOTIFICATION, PROFILE_SET_NOTIFICATION_PATCH, PROFILE_NOTIFICATION_SET_LOADER_STATE, PROFILE_NOTIFICATION_LOADERS } from './profile-notification-types.store';

//@ts-ignore
import { ActivityStatus } from '@/common/enums';
import { IProfileNotification } from '../../models/profile-notification';

export const mutations: MutationTree<IProfileNotificationState> = {
  [ PROFILE_NOTIFICATION_LOADING ]: (state: IProfileNotificationState, activityStatus: ActivityStatus) => {
    state.activityStatus = activityStatus;
  }
  , [ PROFILE_SET_NOTIFICATION ]: (state: IProfileNotificationState, payload: {
    activityStatus: ActivityStatus,
    profileNotifications: { section_notification_name: string, section_notification_option: IProfileNotification[] }[],
  }) => {

    state.profileNotifications = payload.profileNotifications
    state.activityStatus = payload.activityStatus;
    localStorage.setItem('profile-notification', JSON.stringify(state.profileNotifications))
  }
  , [ PROFILE_SET_NOTIFICATION_PATCH ]: (state: IProfileNotificationState, notification: IProfileNotification) => {
    const sectionIndex: number = state.profileNotifications.findIndex(t => t.section_notification_name === notification.section_name);
    if (sectionIndex > -1) {
      const notifIndex: number= state.profileNotifications[sectionIndex].section_notification_option.findIndex(t=> t.setting_id === notification.setting_id)
      if(notifIndex) state.profileNotifications[sectionIndex].section_notification_option[notifIndex] = notification
    }
    localStorage.setItem('profile-notification', JSON.stringify(state.profileNotifications))
  }
  , [ PROFILE_SET_NOTIFICATION_ROWS ]: (state: IProfileNotificationState, payload: IProfileNotification[]) => {

    payload.map(notification => {
      let sectionIndex: number = state.profileNotifications.findIndex(t => t.section_notification_name === notification.section_name);
      if (sectionIndex > -1) {
        let notifIndex: number= state.profileNotifications[sectionIndex].section_notification_option.findIndex(t=> t.setting_id === notification.setting_id)
        state.profileNotifications[sectionIndex].section_notification_option[notifIndex] = notification
      }
    })
  }
  , [ REVERT_PROFILE_NOTIFICATION ]: (state: IProfileNotificationState) => {
    state.profileNotifications = JSON.parse(localStorage.getItem('profile-notification')) as { section_notification_name: string, section_notification_option: IProfileNotification[] }[];
  }
  , [PROFILE_NOTIFICATION_SET_LOADER_STATE] : (state: IProfileNotificationState, payload: { key: any, value: boolean }) => {
      const map: Map<string,boolean> = typeof payload.key === 'string' ? 
                                new Map([ [payload.key ,payload.value] ]) : 
                                      new Map(payload.key.map( (key: string) => [key,payload.value]))
  
      state.loaders= new Map([
        ...state.loaders,
        ...map
      ])
  }
}



// WEBPACK FOOTER //
// ./src/store/profile-notification/profile-notification-mutations.store.ts